<template>
  <div class="personal-center">
    <div class="wrapper">
      <left-menu :userinfo="shareData.userInfo"></left-menu>
      <div class="router-view">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import LeftMenu from "@/views/pages/personal-center/component/LeftMenu";
import eventBus from "@/utils/eventBus";
import store from "@/store/index";
export default {
  components: {
    LeftMenu,
  },
  props: {},
  data() {
    return {
      userInfo: {},
      shareData: store.state,
    };
  },
  watch: {},
  computed: {},
  methods: {
    async getUserInfo() {
      try {
        const res = await this.$api.getUserInfo({
          params: {
            "access-token": localStorage.getItem("token"),
          },
        });
        this.userInfo = res.data.info;
        store.setUserInfoAction(res.data.info);
        sessionStorage.setItem("userinfo", JSON.stringify(this.userInfo));
        // console.log('===',res);
      } catch (error) {}
    },
  },
  created() {
    // 
    console.log('personal-center');
    this.getUserInfo();
  },
  mounted() {},
  beforeDestroy() {
    // console.log('beforeDestroy');
  },
};
</script>
<style lang="scss" scoped>
.personal-center {
  min-height: 50vh;
  background-color: #f8f8f8;
  .wrapper {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .router-view {
      margin: 30px 0;
      width: 820px;
      min-height: 50vh;
      background-color: #fff;
      border-radius: 10px;
    }
  }
}
</style>
